function backOut(element) {
    var mobileNav = document.querySelector(".mobile-site-nav");
    var openSubNav = mobileNav.querySelector(".mobile-site-nav__menu.submenu-open-slideIn");
    var openChildNav = mobileNav.querySelector(".mobile-site-nav__menu.slidein-target-2.submenu-open-slideIn");

    if (openSubNav) {
        if (openChildNav) {
            var openSubNavParent = openChildNav.parentNode;
            openChildNav.classList.remove("submenu-open-slideIn");
            // openChildNav.removeAttribute("style");

        } else {
            var openSubNavParent = openSubNav.parentNode;
            openSubNav.classList.remove("submenu-open-slideIn");
            // openSubNav.removeAttribute("style");
            document.body.classList.remove('sub-menu-open');
        }
    } else {
        var closeElement = document.querySelector(".close-mobile-menu.js-close-mobile-menu");
        document.body.classList.remove('sub-menu-open');
        closeElement.click();
    }

    /*
    var element = document.querySelector('.mobile-site-nav__menu');
    element.style.position = "unset";
    element.classList.remove("submenu-open-slideIn");
    element.style.display = "none";
    */
}
$(document).ready(function() {
    $(document).click(function(e) {
        if (e.target.id != 'multilevel-menu' && !$('#multilevel-menu').find(e.target).length && e.target.id != 'shopify-section-header' && !$('#shopify-section-header').find(e.target).length) {
            $("#multilevel-menu nav .new-desktop-menu").hide().removeClass('main-menu-show');
            $(document.body).removeClass('is-menu-open');
        }
    });
    $(".desktop-new-nav-item-1").click(function(e) {
        $(document.body).toggleClass('is-menu-open');
        $("#multilevel-menu nav > .new-desktop-menu").toggle('show').toggleClass('main-menu-show');
        if ($('.header-nav-vertical li').hasClass('open')) {
            $('.header-nav-vertical li').removeClass('open');
        }
    });

    $(".second-level-menu .site-nav__link").off().click(function(e) {
        $(this).parent().addClass('open').siblings().removeClass('open');
    });
    if ($('.annoucement-slick').length > 0)
    {
        $('.annoucement-slick').slick(
        {
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 2000,
            arrows: false,
            responsive: [
            {
                breakpoint: 768,
                settings:
                {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 6000
                }
            }]
        });
    }

    $(".back_button").click(function() {
        var top_nav_title = $(this).parents('.new-mobile-site-nav__item').find('.new-mobile-site-nav__link').attr("data-title");
        var top_nav_url = $(this).parents('.new-mobile-site-nav__item').find('.new-mobile-site-nav__link').attr("data-url");
        
        $( ".mobile-menu-nav--title .nav--title" ).text( 'View all' + ' ' + top_nav_title );
        if( top_nav_url == '/' )
        {
            $( ".mobile-menu-utils .nav--title-url" ).attr( 'href', "#" );
        }
        else
        {
            $( ".mobile-menu-utils .nav--title-url" ).attr( 'href', top_nav_url );
        }
        
        if ($(".mobile-site-nav__menu.submenu-open-slideIn").length < 1) 
        {
            $(".mobile-menu-nav--title .nav--title").empty();
            $(".mobile-menu-nav--title .nav_svg").attr("src", "");
        }
    });

    $(".mega-dropdown__item, .small-dropdown__item").off().click(function() {
        var mega_nav_id = $(this).attr("data-id");
        $(this).addClass("nav_active").siblings().removeClass("nav_active");
        $(".new-nav-menu--sublinks .site-nav__submenu").each(function() {
            var sub_nav_id = $(this).attr("data-id");
            if (sub_nav_id == mega_nav_id) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    });

    jQuery(".new-mobile-site-nav__link").off().click(function(e) {
        var nav_item_name = $(this).attr("data-title");
        var nav_item_url = $( this ).attr( "data-url" );    
        var bg_color = $(this).attr("data-bg_color");
        var text_color = $( this ).attr( "data-text_color" );    
        var nav_item_flameimage = $( this ).parents('.mobile_navitem_newstyle').find('.new-mobile-site-nav__link img').attr("src");     

        $( ".mobile-menu-utils .nav--title-url" ).css( {
            'background-color': bg_color,
            'color': text_color
        });

        if( nav_item_url == '/' )
        {
            $( ".mobile-menu-utils .nav--title-url" ).attr( 'href', "#" );
        }
        else
        {
            $( ".mobile-menu-utils .nav--title-url" ).attr( 'href', nav_item_url );
        }

        
        if ( $(this).attr("data-title").length > 0 ) 
        {

            $( ".mobile-menu-nav--title .nav--title" ).text( 'View all' + ' ' + nav_item_name );
        }
        else
        {
            $( ".mobile-menu-nav--title .nav--title" ).text( 'View all');
        }
 
        if ( nav_item_flameimage != undefined ) 
        {
            $( ".mobile_navitem_newstyle .mobile-menu-nav--title .nav_svg" ).attr("src",nav_item_flameimage);
        }

        if (jQuery(this).attr('href') == "/" || jQuery(this).attr('href') == "#") {
            e.preventDefault();
            jQuery(this).parent().siblings().removeClass("is-menuOpen");
            jQuery(document.body).addClass('sub-menu-open');
            jQuery(this).parent().toggleClass("is-menuOpen");
            jQuery(this).siblings('button').toggleClass('submenu-open');
            // jQuery(this).siblings('ul').slideToggle(250);
            jQuery(this).siblings('ul').toggleClass('submenu-open-slideIn');
        }
    });

    jQuery(".new-mobile-site-nav__link + .mobile-site-nav__icon").off().click(function(e) {
        var linkTag = jQuery(this).siblings('.new-mobile-site-nav__link');
        if (linkTag.length > 0) 
        {
            var nav_item_name = linkTag.attr("data-title");
            var nav_item_url = linkTag.attr("data-url");
            var nav__svg = linkTag.children(".mobile-nav-new-block").attr("data-img");
            var bg_color = $(this).attr("data-bg_color");
            var text_color = $( this ).attr( "data-text_color" );    
            
            var nav_item_flameimage = $( this ).parents('.mobile_navitem_newstyle').find('.new-mobile-site-nav__link img').attr("src");     
            $( ".mobile-menu-utils .nav--title-url" ).css( {
                'background-color': bg_color,
                'color': text_color
            });

            if ( nav_item_flameimage != undefined ) 
            {
                $( ".mobile_navitem_newstyle .mobile-menu-nav--title .nav_svg" ).attr("src",nav_item_flameimage) ;
            }
            
            if( nav_item_url == '/' )
            {
                $( ".mobile-menu-utils .nav--title-url" ).attr( 'href', "#" );
            }
            else
            {
                $( ".mobile-menu-utils .nav--title-url" ).attr( 'href', nav_item_url );
            }

            if ( nav_item_name.length > 0 ) 
            {

                $( ".mobile-menu-nav--title .nav--title" ).text( 'View all' + ' ' + nav_item_name );
            }
            else
            {
                $( ".mobile-menu-nav--title .nav--title" ).text( 'View all');
            }
            
            if ( nav__svg != undefined && nav__svg != "" ) 
            {
                
                $(".mobile-menu-nav--title .nav_svg").attr("src", nav__svg);
            }
            if (linkTag.attr('href') == "/" || linkTag.attr('href') == "#") {
                e.preventDefault();
                jQuery(document.body).addClass('sub-menu-open');
            }
        }
    });

    jQuery(".mobile-site-nav__link").off().click(function(e) {

        if ($(this).length > 0) {
            var nav_item_name = $(this).attr("data-title");
            var nav_item_url = $(this).attr("data-url");

            if( nav_item_url == '/' )
            {
                $( ".mobile-menu-utils .nav--title-url" ).attr( 'href', "#" );
            }
            else
            {
                $( ".mobile-menu-utils .nav--title-url" ).attr( 'href', nav_item_url );
            }
            
            if ( $(this).attr("data-title").length > 0 ) 
            {

                $(".mobile-menu-nav--title .nav--title").text('View all' + ' ' + nav_item_name);
            }
            else
            {
                $( ".mobile-menu-nav--title .nav--title" ).text( 'View all');
            }
        }
    });

    $(".sticky-mega-nav--item").click(function() {
        // $(".header-navigation").toggleClass("header-navigation--open");
        // $(".header-navigation").addClass("sticky-nav--open");
        document.querySelector(".js-mobile-menu-icon").click();
        $('body').addClass('menu-sticky mobile-menu-open');

    });

    $(window).scroll(function() {
        var sticky = $('.header--sticky'),
            scroll = $(window).scrollTop();

        if (scroll >= 50) {
            sticky.addClass('fixed');
            $('body').addClass('menu-sticky');
        } else {
            sticky.removeClass('fixed');
            $('body').removeClass('menu-sticky');
        }
    });

    $(".close-mobile-menu.js-close-mobile-menu").off().click(function() {
        $(".mobile--navigation .mobile-site-nav__icon").removeClass("submenu-open");
        $(".mobile-menu-nav--title .nav_svg").attr("src", "");
        $("body").removeClass("sub-menu-open");
        if ($('.header-nav-vertical li').hasClass('open')) {
            $('.header-nav-vertical li').removeClass('open');
        }
    });

    if ($(window).innerWidth() > 1024) {
        $('.mega-dropdown__item.grid__item').off().hover(function() {
            jQuery(".site-nav__submenu").hide();
            jQuery(".site-nav__submenu[data-id='" + jQuery(this).data('id') + "']").show();
        }, function() {
            if (!$(".new-nav-menu--sublinks:hover").length > 0) {
                jQuery(".site-nav__submenu[data-id='" + jQuery(this).data('id') + "']").hide();
            }
        });

    }

    $(".new_nav_search").click(function() {
        $(".search-bar--open.search-bar--open-mobile").show();
        $("body").addClass("open_search_bar");
        $(".new_nav_search").hide();
        // $(".search-bar__container .mobile-nav-logo").hide();
    });
    
    $(".search-form__icon-close.new_nav_search_icon").click(function() {
        $(".search-bar--open.search-bar--open-mobile").hide();
        $("body").removeClass("open_search_bar");
        $(".new_nav_search, .mobile-search-form-focus").show();
        $('.mobile-serach-input').val('');
        searchValueIndex();
    });

    function searchValueIndex() {
        let searchValue = document.querySelector(".mobile-serach-input").value;
        console.log(searchValue.length);
        if (searchValue.length > 0) {
            document.querySelector('.mobile-search').style.display = "block";
            document.querySelector('.mobile-search-form-focus').style.display = "none";
        } else {
            document.querySelector('.mobile-search').style.display = "none";
            document.querySelector('.mobile-search-form-focus').style.display = "block";
        }
    }


});